( function( $ ) {

    $(document).ready( function() {

        if ( $('.wp-block-st-main-nav').length > 0 ) {

            // Set nav columns
            $('.wp-block-st-main-nav .wp-block-navigation__container').each( function() {
                let count = $(this).children('li').length;
                if ( count > 3 ) {
                    $(this).addClass('two-cols');
                }
            });
            // Set megamenu height
       // Function to set megamenu dimensions
       function setMegamenuDimensions() {
        $('.subnav-megamenu').each(function() {
            let height = $(this).children().outerHeight() + 'px';
            $(this).css('--body-height', height);

            //megamenu width
            var headerRightNav = $('.header-right-nav');
            if (headerRightNav.length) {
                // Get the distance from left margin to the element
                var distanceFromLeft = headerRightNav.offset().left;
                
                // Calculate the megamenu width (viewport width minus distance from left)
                var megamenuWidth = $(window).width() - distanceFromLeft;
                
                // Set the CSS variable on the document root
                $(this).css('--megamenu-width', megamenuWidth + 'px');
            }
        });
    }

    // Run immediately and on load/resize
    setMegamenuDimensions();
    $(window).on('load resize', setMegamenuDimensions);
    
    // Additional fallback - run after a short delay to catch any delayed rendering
    setTimeout(setMegamenuDimensions, 100);
    setTimeout(setMegamenuDimensions, 500); // Another fallback

// megamenu width
$('.btn_return').on('click', function(e) {
    e.preventDefault();
    $('.site-header').removeClass('menu-active');
    $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
});


            // Trigger megamenu
            $('.megamenu-toggle').on( 'click', function( e ) {
               e.preventDefault(); 

               let $this = $(this);

               if ($this.parent('.wp-block-st-main-nav__nav-item').hasClass('is-active')) {
                $this.closest('.site-header').removeClass('menu-active');
                   $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
               } else {
                   $('.wp-block-st-main-nav__nav-item').removeClass('is-active');

                   if ($this.closest('.site-header').hasClass('menu-active')) {
                    window.setTimeout(function() {
                        $this.parent('.wp-block-st-main-nav__nav-item').toggleClass('is-active');
                    }, 600);
                    
                   } else {
                    $this.parent('.wp-block-st-main-nav__nav-item').toggleClass('is-active');
                   }
                   $this.closest('.site-header').addClass('menu-active');
                   
               }
               
            });

            $('.wp-block-st-main-nav__button-open').on( 'click', function( e ) {
                e.preventDefault();
                $( 'html' ).toggleClass( 'toggle-main-nav' );
                $('.site-header').removeClass('menu-active');
                $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
            });
            $(document).on('keydown', function(e) {
                if (e.keyCode === 27) { // ESC key
                    if ($('html').hasClass('toggle-main-nav')) {
                        $('html').removeClass('toggle-main-nav');
                        $('.site-header').removeClass('menu-active');
                        $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
                    }
                }
            });
            // Close megamenu if anywhere outside is clicked or if an on page link is clicked.
            $(document).on( 'click', function( e ) {
                if ( !$( e.target ).closest( '.wp-block-st-main-nav' ).length ) {
                    $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
                    $('.site-header').removeClass('menu-active');
                }
            });

            // Close megamenu if an on page link is clicked.
            $('.wp-block-st-main-nav__subnav a').on( 'click', function( e ) {
                $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
                $('.site-header').removeClass('menu-active');
            });
            

        }




    //duplicate menu buttons for topnav
    if ($('.wp-block-buttons.top-nav').length) {
        // Clone the element (true parameter includes event handlers and data)
        var clonedElement = $('.wp-block-buttons.top-nav').clone(true);
        
        // Append the cloned element to the target container
        $('.mobile-nav-buttons.extra-btns').append(clonedElement);
        
        // Optional: Add a class to identify it as a cloned element
        clonedElement.addClass('cloned-nav');
    } 

    //menu-items clickable 


    
        $('.menu-item').each(function() {
            const $menuItem = $(this);
            const $buttonLink = $menuItem.find('.wp-block-button__link[href]');
            
            if ($buttonLink.length) {
                // Get the href from the button link
                const href = $buttonLink.attr('href');
                
                // Change the <a> in the button to a <div> (keep all classes and content)
                $buttonLink.replaceWith(function() {
                    return $('<div>', {
                        'class': $(this).attr('class'),
                        'html': $(this).html(),
                        'data-text': $(this).attr('data-text')
                    });
                });
                
                // Change the .menu-item from div to an <a> with the href
                $menuItem.replaceWith(function() {
                    return $('<a>', {
                        'href': href,
                        'class': $(this).attr('class'),
                        'html': $(this).html()
                    });
                });
            }
        });


        
 
    } );

} )( jQuery );
